export class RequestDeviceImportModel {
    requestId: number;
    fileName: string;
    fileData: string;
}